import React from 'react';
import CardsPage from './CardsPage';
import colorData from '../Data/colorData';

function Rung() {
    return <CardsPage data={colorData} />;
}

export default Rung;
